// extracted by mini-css-extract-plugin
export default {"input":"Search_input__U18Wd","btn":"Search_btn__D1GIn"};